<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formTransferConstructionSite">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="expandedForm ? 'Contraer Formulario' : 'Expandir Formulario'"
                [icon]="'pi pi-sliders-h'" [severity]="'contrast'"
                (onClick)="expandedForm = !expandedForm"></app-custom-button>
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>
              <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                (onClick)="deleteTransferConstructionSite()">
              </app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewTransferConstructionSite()">
              </app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="transferConstructionSiteContract.userNameCreate"
                [createDate]="transferConstructionSiteContract.createDate"
                [userNameUpdate]="transferConstructionSiteContract.userNameUpdate"
                [updateDate]="transferConstructionSiteContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-4 col-sm-6 col-12">
            <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
              [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event, false)"></app-custom-select>
          </div>
          <div class="col-lg-1 col-md-2 col-sm-2 col-6">
            <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
              [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
          </div>
          <div class="col-lg-1 col-md-2 col-sm-3 col-6">
            <app-custom-datepicker formControlName="dateTransferConstructionSite" [labelText]="'Fecha'"
              (onChangeDate)="changeDateTransferConstructionSite()" [required]="true"></app-custom-datepicker>
          </div>
          <div class="col-lg-1 col-md-2 col-sm-2 col-6">
            <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="transferConstructionSiteStateString">
            </app-custom-tag>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-6 d-flex align-items-center">
            <div class="mb-1">
              <label class="form-label"></label>
              <div class="d-flex gap-1">
                <app-custom-button [title]="titleStateTransferConstructionSite"
                  [icon]="iconStateTransferConstructionSite" [severity]="'primary'"
                  (onClick)="changeStateTransferConstructionSite()">
                </app-custom-button>
                <app-custom-button *ngIf="swconfirmTransfer" [disabled]="disabledConfirmTransfer"
                  [icon]="'pi pi-check-circle'" [severity]="'success'" [title]="'Confirmar'"
                  (onClick)="confirmTransfer()"></app-custom-button>
                <app-custom-button [title]="'Anular'" [icon]="'pi pi-ban'" [severity]="'warn'" [disabled]="false"
                  (onClick)="annulTransferConstructionSite()"></app-custom-button>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-8 col-sm-2 col-12">
            <div class="d-flex justify-content-lg-end flex-wrap">
              <div class="col-lg-2 col-md-2 col-sm-2 col-3 me-1">
                <app-custom-input-text [labelText]="'Devolución'" [disabled]="true" [value]="devolutionConsecutive">
                </app-custom-input-text>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-3 me-1">
                <app-custom-input-text [labelText]="'Remisión'" [disabled]="true" [value]="remissionConsecutive">
                </app-custom-input-text>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-3 col-sm-2 col-4">
                <app-custom-input-text [labelText]="'Periodo'" [disabled]="true" [value]="dataPeriod"
                  [class]="rentalPeriod.active == true ? '' : 'state-inactive'">
                </app-custom-input-text>
              </div>
            </div>
          </div>
        </div>
        <!-- Extendido -->
        <div class="row mt-1 d-flex justify-content-between" [ngClass]="expandedForm ? 'visible': ''">
          <div class="col-lg-12 col-12">
            <div class="row">
              <!-- ORIGEN -->
              <div class="col-12 col-lg-6 mb-3">
                <div class="p-1 border rounded h-100">
                  <div class="d-flex justify-content-between align-items-center mb-3 border-bottom ">
                    <h6>Origen</h6>
                    <div class="form-check">
                      <app-custom-checkbox formControlName="originSwDontChargeInvoiceDay"
                        [labelText]="'No cobrar día de traslado'"
                        (onChangeCheckBox)="changeSwDontChargeInvoiceDay($event)"></app-custom-checkbox>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-2 col-12">
                      <app-custom-autocomplete formControlName="originClientId" [labelText]="'Cliente'"
                        [list]="listClients" [required]="true" [class]="originCostCenterInvalid ? 'state-inactive' : ''"
                        (onChangeSelect)="changeOriginClient($event)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-12 col-sm-6 col-md-5 col-lg-5">
                      <app-custom-autocomplete formControlName="originCostCenterId" [labelText]="'C.Costos'"
                        [list]="originCostCenters" [required]="true" (onChangeSelect)="changeOriginCostCenter($event)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                      <app-custom-datepicker formControlName="originDateInvoice" [labelText]="'Fecha Devolución'"
                        [required]="true">
                      </app-custom-datepicker>
                    </div>
                  </div>
                  <div class="row" [hidden]="!expandedForm">
                    <div class="col-md-5 col-sm-6 col-12 col-lg-5">
                      <app-custom-autocomplete formControlName="originTransporterId" [labelText]="'Transportador'"
                        [list]="listTransporters" (onChangeSelect)="getOriginTransporter($event)" [required]="true">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-md-5 col-sm-6 col-12 col-lg-5">
                      <app-custom-autocomplete formControlName="originVehicleId" [labelText]="'Vehículo'"
                        [list]="listVehicles" (onChangeSelect)="getOriginVehicle($event)" [required]="true">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-3 col-6 form-label">
                      <app-custom-input-decimal formControlName="originTransportValue" [labelText]="'Vr.Transporte'"
                        (onChangeNumber)="changeOriginTransportValue()"></app-custom-input-decimal>
                    </div>
                  </div>
                </div>
              </div>
              <!-- DESTINO -->
              <div class="col-12 col-lg-6 mb-3">
                <div class="p-1 border rounded h-100">
                  <div class="d-flex justify-content-between align-items-center mb-3 border-bottom">
                    <h6 class="mb-1">Destino</h6>
                    <div class="col-lg-8 col-md-8 col-sm-8 col-8 me-1 d-flex justify-content-end">
                      <div class="text-danger fw-bold">
                        {{ differentClientsMessage }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-2 col-12">
                      <app-custom-autocomplete formControlName="destinyClientId" [labelText]="'Cliente'"
                        [list]="listClients" [required]="true" [class]="destinyClientInvalid ? 'state-inactive' : ''"
                        (onChangeSelect)="changeDestinyClient($event)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-12 col-sm-6 col-md-5 col-lg-5">
                      <app-custom-autocomplete formControlName="destinyCostCenterId" [labelText]="'C.Costos'"
                        [list]="destinyCostCenters" [required]="true"
                        (onChangeSelect)="changeDestinyCostCenter($event)">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                      <app-custom-datepicker formControlName="destinyDateInvoice" [labelText]="'Fecha Remisión'"
                        [required]="true">
                      </app-custom-datepicker>
                    </div>
                  </div>
                  <div class="row" [hidden]="!expandedForm">
                    <div class="col-12 col-sm-6 col-md-5 col-lg-5">
                      <app-custom-autocomplete formControlName="destinyTransporterId" [labelText]="'Transportador'"
                        [list]="listTransporters" (onChangeSelect)="getDestinyTransporter($event)" [required]="true">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-12 col-sm-6 col-md-5 col-lg-5">
                      <app-custom-autocomplete formControlName="destinyVehicleId" [labelText]="'Vehículo'"
                        [list]="listVehicles" (onChangeSelect)="getDestinyVehicle($event)" [required]="true">
                      </app-custom-autocomplete>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-3 col-6 form-label">
                      <app-custom-input-decimal formControlName="destinyTransportValue" [labelText]="'Vr.Transporte'"
                        (onChangeNumber)="changeDestinyTransportValue()"></app-custom-input-decimal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-sm-12 col-lg-12">
          <div class="row" *ngIf="expandedForm">
            <div class="col-lg-5 col-md-5 col-sm-12 col-12">
              <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                [rows]="1"></app-custom-textarea>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-12 d-flex justify-content-start align-items-end">
              <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                [variant]="undefined" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-transfer-construction-site-detail [disabledDetail]="disabledDetail" [disabledActions]="disabledActions"
      [transferConstructionSiteModel]="transferConstructionSiteContract"
      (emitQuantityDetails)="onQuantityDetails($event)" (hasQuantityInZero)="hasQuantityInZero = $event">
    </app-transfer-construction-site-detail>
  </div>
</section>
<!-- Imprimir Traslado Entre Obras -->
<div id="container-print-transfer-construction-site">
  <app-print-transfer-construction-site *ngIf="printTransferConstructionSiteFormat"
    id="print-transfer-construction-site" [companyId]="companyId" [formatModel]="formatModel"
    [transferConstructionSitePrintModel]="transferConstructionSitePrintModel" [editFormat]="false" [focusText]="false"
    (finishLoadingPrintTransfer)="finishLoading($event)">
  </app-print-transfer-construction-site>
</div>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>